<template>
    <div id="container" class="container">
        <router-view  v-wechat-title="$route.meta.title"/>
    </div>
</template>

<script>
  export default {
    name: 'app',
    methods: {
      switchStatus() {
        this.$post({
          url: this.$apis.switchOnlineStatus,
          param: {
            type: 2
          }
        })
      }
    }
  }
</script>

<style>
   html{
       background:#fff;
   }
    /* html {
        height: 100%;
    }

    body {
        height: 100%;
    }

    .container {
        height: 100%;
    } */
</style>
